import {useState, type ChangeEvent, type FocusEvent} from 'react'

const NOTA_MAX_LENGTH = 300

/** Duplicates the Textarea's maxLength: a paste can bypass native truncation. */
function validateNota(raw: string): string | null {
  return raw.length > NOTA_MAX_LENGTH ? 'errors.notaTooLong' : null
}

export function useNotaField() {
  const [nota, setNota] = useState('')
  const [notaError, setNotaError] = useState<string | undefined>()

  function reset() {
    setNota('')
    setNotaError(undefined)
  }

  function onChange(e: ChangeEvent<HTMLTextAreaElement>) {
    setNota(e.target.value)
    setNotaError(undefined)
  }

  function onBlur(e: FocusEvent<HTMLTextAreaElement>) {
    setNotaError(validateNota(e.target.value) ?? undefined)
  }

  function validate(): string | null {
    const err = validateNota(nota)
    setNotaError(err ?? undefined)
    return err
  }

  return {nota, notaError, reset, onChange, onBlur, validate, maxLength: NOTA_MAX_LENGTH}
}
